import { render, staticRenderFns } from "./recent.vue?vue&type=template&id=acfe3d92"
import script from "./recent.vue?vue&type=script&lang=js"
export * from "./recent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports